(function(){
function openCartDrawer(){var d=document.getElementById('cart-drawer'),o=document.getElementById('cart-drawer-overlay');if(!d||!o)return;d.style.right='0';o.style.display='block';document.body.style.overflow='hidden';loadCart();}
function closeCartDrawer(){var d=document.getElementById('cart-drawer'),o=document.getElementById('cart-drawer-overlay');if(!d||!o)return;d.style.right='-420px';o.style.display='none';document.body.style.overflow='';}
function setEmptyUI(e){var t=document.getElementById('cart-drawer-trust'),u=document.getElementById('cart-upsell-wrap'),s=document.getElementById('cart-shipping-bar'),p=document.getElementById('cart-promo'),v=e?'none':'';if(t)t.style.display=v;if(u)u.style.display=v;if(s)s.style.display=v;if(p)p.style.display=v;}
function renderEmptyCarouselHTML(){var cols=window.__emptyCartCollections||[];if(!cols.length)return '<a href="/collections/all">Explorer la collection</a>';var cards=cols.map(function(c){var img=c.image?'<img src="'+c.image+'" alt="" loading="lazy">':'';return '<a href="'+c.url+'" class="cart-drawer__empty-card"><div class="cart-drawer__empty-card-media">'+img+'</div><p class="cart-drawer__empty-card-title">'+c.title+'</p></a>';}).join('');return '<div class="cart-drawer__empty-carousel-wrap"><div class="cart-drawer__empty-carousel">'+cards+'</div></div>';}

function isAlo(item){var v=(item.vendor||'').toUpperCase(),h=(item.handle||'').toLowerCase(),t=(item.product_title||'').toLowerCase();return v==='ONYSTORE'||h.indexOf('alo')!==-1||t.indexOf('alo')!==-1;}
function isMaillot(item){var h=(item.handle||'').toLowerCase(),t=(item.product_title||'').toLowerCase();return h.indexOf('maillot')!==-1||t.indexOf('maillot')!==-1;}
function isEnsembleEte(item){var h=(item.handle||'').toLowerCase(),t=(item.product_title||'').toLowerCase();return(h.indexOf('ensemble')!==-1||t.indexOf('ensemble')!==-1)&&!isMaillot(item)&&!isAlo(item);}

// Produits cadeaux Alo (exclus du calcul du seuil)
var ALO_GIFT_PIDS=[15614720934236,15614720999772]; // casquette, chaussettes
var ALO_GIFT_VIDS=[57796632904028,57796633002332]; // Noir taille unique, Noir 35
var ALO_CHAUSSETTES_PID=15614720999772;
var CHAUSSETTES_VARIANTS={'Noir':{'35':57796633002332,'36':57796633035100,'37':58208873709916,'38':58208873742684,'39':58208873775452,'40':58208873808220,'41':58208873840988,'42':58208873873756,'43':58208873906524,'44':58208873939292,'45':58208873972060},'Blanc':{'35':58208868532572,'36':58208868565340,'37':58208874004828,'38':58208874037596,'39':58208874070364,'40':58208874103132,'41':58208874135900,'42':58208874168668,'43':58208874201436,'44':58208874234204,'45':58208874266972}};
async function changeAloCadeauVariant(itemKey,color,size){
  var vid=CHAUSSETTES_VARIANTS[color]&&CHAUSSETTES_VARIANTS[color][size];
  if(!vid)return;
  try{
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:itemKey,quantity:0})});
    await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1,properties:{_cadeau_alo:'1'}})});
  }catch(e){}
  loadCart();
}
window.changeAloCadeauVariant=changeAloCadeauVariant;

async function syncAloGifts(cart){
  var aloTotal=0;
  cart.items.forEach(function(item){
    if(isAlo(item)&&ALO_GIFT_PIDS.indexOf(item.product_id)===-1){
      aloTotal+=item.final_price*item.quantity;
    }
  });
  var threshold=10000;
  if(aloTotal>=threshold){
    var toAdd=[];
    for(var i=0;i<ALO_GIFT_PIDS.length;i++){
      var pid=ALO_GIFT_PIDS[i];
      var alreadyGift=cart.items.some(function(it){return it.product_id===pid&&it.properties&&it.properties['_cadeau_alo'];});
      if(!alreadyGift)toAdd.push(ALO_GIFT_VIDS[i]);
    }
    if(toAdd.length){
      for(var j=0;j<toAdd.length;j++){
        try{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:toAdd[j],quantity:1,properties:{_cadeau_alo:'1'}})});}catch(e){}
      }
      return true;
    }
  }else{
    var toRemove=[];
    cart.items.forEach(function(item){
      if(ALO_GIFT_PIDS.indexOf(item.product_id)!==-1&&item.properties&&item.properties['_cadeau_alo']){
        toRemove.push(item.key);
      }
    });
    if(toRemove.length){
      for(var j=0;j<toRemove.length;j++){
        try{await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:toRemove[j],quantity:0})});}catch(e){}
      }
      return true;
    }
  }
  return false;
}

function aloBanner(cart){
  var aloTotal=0,hasAlo=false;
  cart.items.forEach(function(item){
    if(isAlo(item)&&ALO_GIFT_PIDS.indexOf(item.product_id)===-1){hasAlo=true;aloTotal+=item.final_price*item.quantity;}
  });
  if(!hasAlo)return '';
  var threshold=10000;
  if(aloTotal>=threshold){
    return '';
  }else{
    var rem=threshold-aloTotal;
    return '<div style="background:#f8fafc;border:1px solid #cbd5e1;border-radius:10px;padding:12px 14px;margin-bottom:10px;">'
      +'<div style="display:flex;align-items:center;gap:8px;"><span style="font-size:12px;font-weight:700;color:#334155;">Plus que <strong style="color:#0ea5e9;">'+(rem/100).toFixed(2).replace('.',',')+' €</strong> d\'achats Alo pour recevoir casquette + chaussettes <span style="color:#16a34a;font-weight:800;">OFFERTES !</span></span></div>'
      +'</div>';
  }
}

function bxgyBanners(cart){
  var mp=0,mf=0,ep=0,ef=0;
  cart.items.forEach(function(item){
    var qty=item.quantity;
    var free=item.final_price===0&&item.original_price>0;
    if(isMaillot(item)){if(free)mf+=qty;else mp+=qty;}
    if(isEnsembleEte(item)){if(free)ef+=qty;else ep+=qty;}
  });
  var mc=Math.max(0,Math.floor(mp/2)-mf),ec=Math.max(0,Math.floor(ep/2)-ef),html='';
  if(mc>0){html+='<div style="background:#fff7ed;border:1px solid #f59e0b;border-radius:8px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:center;gap:8px;"><span style="font-size:12px;font-weight:700;color:#92400e;">Ajoute '+(mc===1?'1 maillot de plus':mc+' maillots de plus')+' → '+(mc===1?"il t'est":"ils te sont")+' <span style="color:#16a34a;font-weight:800;">OFFERT'+(mc>1?'S':'')+' !</span></span></div>';}else if(mp===1&&mf===0){html+='<div style="background:#fff7ed;border:1px solid #f59e0b;border-radius:8px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:center;gap:8px;"><span style="font-size:12px;font-weight:700;color:#92400e;">Ajoute encore <strong>1 maillot</strong> et le 3ème te sera <span style="color:#16a34a;font-weight:800;">OFFERT</span></span></div>';}
  if(ec>0){html+='<div style="background:#f0fdf4;border:1px solid #86efac;border-radius:8px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:center;gap:8px;"><span style="font-size:12px;font-weight:700;color:#14532d;">Ajoute '+(ec===1?'1 ensemble de plus':ec+' ensembles de plus')+' → '+(ec===1?"il t'est":"ils te sont")+' <span style="color:#16a34a;font-weight:800;">OFFERT'+(ec>1?'S':'')+' !</span></span></div>';}else if(ep===1&&ef===0){html+='<div style="background:#f0fdf4;border:1px solid #86efac;border-radius:8px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:center;gap:8px;"><span style="font-size:12px;font-weight:700;color:#14532d;">Ajoute encore <strong>1 ensemble</strong> et le 3ème te sera <span style="color:#16a34a;font-weight:800;">OFFERT</span></span></div>';}
  return html;
}

async function loadCart(){
  try{
    var res=await fetch('/cart.js');
    var cart=await res.json();
    var changed=await syncAloGifts(cart);
    if(changed){var res2=await fetch('/cart.js');cart=await res2.json();}
    var container=document.getElementById('cart-drawer-items');
    var totalEl=document.getElementById('cart-drawer-total');
    if(!container||!totalEl)return;
    if(cart.items.length===0){
      container.innerHTML='<div class="cart-drawer__empty"><p class="cart-drawer__empty-text">Votre panier est vide</p><p class="cart-drawer__empty-sub">Decouvrez nos pieces du moment</p></div>'+renderEmptyCarouselHTML();
      totalEl.textContent='0,00  €';
      setEmptyUI(true);
      return;
    }
    setEmptyUI(false);
    var nudges=aloBanner(cart)+bxgyBanners(cart);
    var sortedItems=cart.items.slice().sort(function(a,b){var aG=a.properties&&a.properties['_cadeau_alo']?1:0,bG=b.properties&&b.properties['_cadeau_alo']?1:0;return aG-bG;});
    container.innerHTML=nudges+sortedItems.map(function(item,idx){
      var vl=(item.variant_title&&item.variant_title!=='Default Title')?item.variant_title:'';
      var isAloCadeau=!!(item.properties&&item.properties['_cadeau_alo']);
      var isFree=isAloCadeau||(item.final_price===0&&item.original_price>0);
      var isBxgyItem=!isAloCadeau&&isFree&&(isMaillot(item)||isEnsembleEte(item));
      var price=isAloCadeau
        ?'<span style="font-size:13px;font-weight:800;color:#16a34a;">CADEAU</span>'+(item.original_price>0?'<span style="font-size:11px;color:#999;text-decoration:line-through;margin-left:6px;">'+(item.original_price/100).toFixed(2).replace('.',',')+' €</span>':'')
        :(isBxgyItem
          ?'<span style="font-size:13px;font-weight:800;color:#16a34a;">3ème OFFERT</span><span style="font-size:11px;color:#999;text-decoration:line-through;margin-left:6px;">'+(item.original_price/100).toFixed(2).replace('.',',')+' €</span>'
          :(isFree
            ?'<span style="font-size:13px;font-weight:800;color:#0ea5e9;">CADEAU OFFERT</span><span style="font-size:11px;color:#999;text-decoration:line-through;margin-left:6px;">'+(item.original_price/100).toFixed(2).replace('.',',')+' €</span>'
            :'<span style="font-size:14px;font-weight:800;">'+(item.final_price/100).toFixed(2).replace('.',',')+' €</span>'));
      var chaussettesSelHTML='';
      if(isAloCadeau&&item.product_id===ALO_CHAUSSETTES_PID){
        var parts=(item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'Noir / 35').split(' / ');
        var curColor=parts[0]||'Noir',curSize=parts[1]||'35';
        var escapedKey="'"+item.key+"'";
        var colorId='alo-color-'+idx,sizeId='alo-size-'+idx;
        var colorOpts=['Noir','Blanc'].map(function(c){return '<option value="'+c+'"'+(c===curColor?' selected':'')+'>'+c+'</option>';}).join('');
        var sizeOpts=['35','36','37','38','39','40','41','42','43','44','45'].map(function(s){return '<option value="'+s+'"'+(s===curSize?' selected':'')+'>'+s+'</option>';}).join('');
        chaussettesSelHTML='<div style="display:flex;gap:6px;margin-top:6px;">'
          +'<select id="'+colorId+'" onchange="window.changeAloCadeauVariant('+escapedKey+',this.value,document.getElementById(\''+sizeId+'\').value)" style="flex:1;font-size:10px;border:1px solid #ddd;border-radius:6px;padding:3px 6px;background:#f9f9f9;cursor:pointer;color:#333;">'+colorOpts+'</select>'
          +'<select id="'+sizeId+'" onchange="window.changeAloCadeauVariant('+escapedKey+',document.getElementById(\''+colorId+'\').value,this.value)" style="flex:1;font-size:10px;border:1px solid #ddd;border-radius:6px;padding:3px 6px;background:#f9f9f9;cursor:pointer;color:#333;">'+sizeOpts+'</select>'
          +'</div>';
      }
      var badges='';
      if(item.discount_allocations&&item.discount_allocations.length>0&&cart.discount_applications){
        badges=item.discount_allocations.map(function(a){
          var app=cart.discount_applications[a.discount_application_index];
          return app?'<span style="display:inline-flex;align-items:center;gap:3px;background:#16a34a;color:#fff;font-size:10px;font-weight:700;letter-spacing:0.05em;padding:2px 8px;border-radius:100px;margin-top:4px;">'+app.title+'</span>':'';
        }).join('');
      }
      return '<div style="display:flex;gap:12px;margin-bottom:16px;padding-bottom:16px;border-bottom:1px solid #f0f0f0;">'
        +'<a href="'+item.url+'" style="flex-shrink:0;position:relative;">'
        +'<img src="'+item.image+'" style="width:72px;height:72px;object-fit:cover;border-radius:8px;display:block;"/>'
        +'</a>'
        +'<div style="flex:1;min-width:0;">'
        +'<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:8px;">'
        +'<div style="flex:1;min-width:0;">'
        +'<p style="font-size:13px;font-weight:700;margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"><a href="'+item.url+'" style="color:inherit;text-decoration:none;">'+item.product_title+'</a></p>'
        +'<p style="font-size:12px;color:#666;margin:0 0 4px;">'+vl+'</p>'
        +badges
        +'</div>'
        +'<button onclick="removeItem(\''+item.key+'\')" style="background:none;border:none;cursor:pointer;padding:4px;opacity:0.6;"><img src="https://cdn.shopify.com/s/files/1/1006/6011/7852/files/bin.png?v=1780529900" width="18" height="18" style="display:block;"></button>'
        +'</div>'
        +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px;">'
        +price
        +(isFree?''
          :'<div style="display:flex;align-items:center;gap:8px;">'
          +'<button onclick="updateQty(\''+item.key+'\','+(item.quantity-1)+')" style="width:24px;height:24px;border:1px solid #ddd;border-radius:50%;background:#fff;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;">−</button>'
          +'<span style="font-size:13px;font-weight:600;">'+item.quantity+'</span>'
          +'<button onclick="updateQty(\''+item.key+'\','+(item.quantity+1)+')" style="width:24px;height:24px;border:1px solid #ddd;border-radius:50%;background:#fff;cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;">+</button>'
          +'</div>')
        +'</div>'
        +chaussettesSelHTML
        +'</div>'
        +'</div>';
    }).join('');
    totalEl.textContent=(cart.total_price/100).toFixed(2).replace('.',',')+' €';
    var de=document.getElementById('cart-discounts');
    if(de){
      if(cart.cart_level_discount_applications&&cart.cart_level_discount_applications.length>0){
        de.innerHTML=cart.cart_level_discount_applications.map(function(d){
          var val=d.type==='percentage'?d.value+'%':(d.total_allocated_amount/100).toFixed(2)+' €';
          return '<div style="display:flex;justify-content:space-between;align-items:center;background:#f0faf0;border:1px solid #22c55e;border-radius:8px;padding:8px 12px;margin-bottom:8px;"><span style="font-size:12px;font-weight:700;color:#16a34a;">Code : '+d.title+'</span><span style="font-size:12px;font-weight:800;color:#16a34a;">&minus;'+val+'</span></div>';
        }).join('');
      }else{de.innerHTML='';}
    }
    var threshold=10000,total=cart.total_price,remaining=Math.max(0,threshold-total),percent=Math.min(100,Math.round(total/threshold*100));
    var sb=document.getElementById('cart-shipping-bar');
    if(sb){
      sb.innerHTML=remaining>0
        ?'<div class="shipping-bar"><p class="shipping-bar__text">Plus que <strong>'+(remaining/100).toFixed(2).replace('.',',')+' €</strong> pour la livraison gratuite</p><div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:'+percent+'%"></div></div></div>'
        :'<div class="shipping-bar shipping-bar--reached"><p class="shipping-bar__text">Tu beneficies de la <strong>livraison gratuite !</strong></p><div class="shipping-bar__track"><div class="shipping-bar__fill" style="width:100%"></div></div></div>';
    }
    loadUpsell(cart);
  }catch(e){console.error('[Kinbo]',e);}
}
async function updateQty(key,qty){try{if(qty<0)qty=0;await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});loadCart();}catch(e){loadCart();}}
async function removeItem(key){try{await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})});loadCart();}catch(e){loadCart();}}

/* ---- Upsell conditionnel : produits de la collection "accessoire upsell" uniquement ----
   Panier avec produit Alo  -> Lot de 3 paires de Chaussettes Alo
   Panier avec sneakers     -> Lot de 3 paires Nike NOIR ou BLANC (choix aleatoire par session) */
var UPSELL_COLLECTION_HANDLE='accessoire-upsell';
var UPSELL_ALO_SOCKS_PID=15614720999772;   // Lot de 3 paires de Chaussettes Alo
var UPSELL_SOCKS_BLACK_PID=15677701259612; // Lot de 3 paires chaussettes Nike NOIR
var UPSELL_SOCKS_WHITE_PID=15677701226844; // Lot de 3 paires chaussettes Nike BLANC
var SNEAKER_COLLECTION_HANDLES=['sneakers','sneakers-de-luxe'];
var __upsellProducts=null,__sneakerIds=null;
var __sockColorPick=Math.random()<0.5?UPSELL_SOCKS_BLACK_PID:UPSELL_SOCKS_WHITE_PID;

async function getUpsellProducts(){
  if(__upsellProducts)return __upsellProducts;
  try{
    var r=await fetch('/collections/'+UPSELL_COLLECTION_HANDLE+'/products.json?limit=50');
    if(r.ok){var d=await r.json();__upsellProducts=d.products||[];}else{__upsellProducts=[];}
  }catch(e){__upsellProducts=[];}
  return __upsellProducts;
}

async function getSneakerIds(){
  if(__sneakerIds)return __sneakerIds;
  var ids=[];
  for(var c=0;c<SNEAKER_COLLECTION_HANDLES.length;c++){
    try{
      for(var page=1;page<=3;page++){
        var r=await fetch('/collections/'+SNEAKER_COLLECTION_HANDLES[c]+'/products.json?limit=250&page='+page);
        if(!r.ok)break;
        var d=await r.json();
        if(!d.products||!d.products.length)break;
        for(var i=0;i<d.products.length;i++){if(ids.indexOf(d.products[i].id)===-1)ids.push(d.products[i].id);}
        if(d.products.length<250)break;
      }
    }catch(e){}
  }
  __sneakerIds=ids;
  return ids;
}

function isGiftItem(it){return !!(it.properties&&it.properties['_cadeau_alo']);}
function looksLikeSneaker(it){var hay=((it.handle||'')+' '+(it.product_title||'')).toLowerCase();return hay.indexOf('sneaker')!==-1||hay.indexOf('basket')!==-1;}

async function loadUpsell(cart){
  try{
    var container=document.getElementById('cart-upsell-product'),wrap=document.getElementById('cart-upsell-wrap');
    if(!container||!wrap)return;
    if(!cart||!cart.items||!cart.items.length){wrap.style.display='none';return;}
    var inCart=cart.items.map(function(i){return i.product_id;});
    var targetPid=null;
    var hasAlo=cart.items.some(function(it){return isAlo(it)&&!isGiftItem(it);});
    if(hasAlo&&inCart.indexOf(UPSELL_ALO_SOCKS_PID)===-1){
      targetPid=UPSELL_ALO_SOCKS_PID;
    }else{
      var sIds=await getSneakerIds();
      var hasSneaker=cart.items.some(function(it){return sIds.length?sIds.indexOf(it.product_id)!==-1:looksLikeSneaker(it);});
      if(hasSneaker){
        var first=__sockColorPick,second=first===UPSELL_SOCKS_BLACK_PID?UPSELL_SOCKS_WHITE_PID:UPSELL_SOCKS_BLACK_PID;
        if(inCart.indexOf(first)===-1)targetPid=first;
        else if(inCart.indexOf(second)===-1)targetPid=second;
      }
    }
    if(!targetPid){wrap.style.display='none';return;}
    var prods=await getUpsellProducts();
    var p=null;
    for(var i=0;i<prods.length;i++){if(prods[i].id===targetPid){p=prods[i];break;}}
    if(!p){wrap.style.display='none';return;}
    var variants=(p.variants||[]).filter(function(v){return v.available!==false;});
    if(!variants.length){wrap.style.display='none';return;}
    wrap.style.display='';
    var imgSrc=(p.images&&p.images[0]&&p.images[0].src)||'';
    var price=parseFloat(variants[0].price).toFixed(2).replace('.',',')+' €';
    var variantHTML;
    if(variants.length>1){
      var opts=variants.map(function(v){return '<option value="'+v.id+'">'+v.title+'</option>';}).join('');
      variantHTML='<select id="upsell-variant" style="flex:1;min-width:0;border:1px solid #ddd;border-radius:6px;padding:4px 6px;font-size:12px;background:#fff;color:#333;">'+opts+'</select>';
    }else{
      var lbl=(variants[0].title&&variants[0].title!=='Default Title')?'<span style="font-size:11px;color:#666;">'+variants[0].title+'</span>':'';
      variantHTML='<input type="hidden" id="upsell-variant" value="'+variants[0].id+'">'+lbl;
    }
    container.innerHTML='<img src="'+imgSrc+'" onerror="this.style.display=\'none\'" style="width:56px;height:56px;object-fit:cover;border-radius:8px;flex-shrink:0;"/>'
      +'<div style="flex:1;min-width:0;">'
      +'<p style="font-size:12px;font-weight:700;margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+p.title+'</p>'
      +'<div style="display:flex;align-items:center;gap:8px;">'+variantHTML+'<span style="font-size:12px;font-weight:800;flex-shrink:0;">'+price+'</span></div>'
      +'</div>'
      +'<button onclick="window.addUpsellToCart(this)" class="cart-upsell-add-btn">Ajouter</button>';
  }catch(e){var w=document.getElementById('cart-upsell-wrap');if(w)w.style.display='none';}
}

async function addUpsellToCart(btn){
  try{
    var s=document.getElementById('upsell-variant');
    if(!s)return;
    if(btn){btn.disabled=true;btn.textContent='...';}
    var res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(s.value,10),quantity:1})});
    if(!res.ok){console.error('[Kinbo upsell] add failed',res.status);if(btn){btn.disabled=false;btn.textContent='Ajouter';}}
    loadCart();
  }catch(e){console.error('[Kinbo upsell]',e);loadCart();}
}

/* ---- Code promo : applique la remise Shopify au panier via /discount/CODE.
   La remise est enregistree cote Shopify AVANT la redirection => le checkout Corsopay la lit.
   Compatible codes uniques Klaviyo (codes de reduction Shopify standard). ---- */
function toggleCartPromo(){
  var f=document.getElementById('cart-promo-form'),t=document.getElementById('cart-promo-toggle');
  if(!f)return;
  f.style.display='flex';
  if(t)t.style.display='none';
  var inp=document.getElementById('cart-promo-input');
  if(inp)inp.focus();
}
async function applyCartPromo(){
  var inp=document.getElementById('cart-promo-input'),btn=document.getElementById('cart-promo-apply'),msg=document.getElementById('cart-promo-msg');
  if(!inp)return;
  var code=inp.value.trim();
  if(!code)return;
  if(btn){btn.disabled=true;btn.textContent='...';}
  if(msg)msg.style.display='none';
  var before=null,after=null;
  try{before=await(await fetch('/cart.js')).json();}catch(e){}
  try{await fetch('/discount/'+encodeURIComponent(code));}catch(e){}
  try{after=await(await fetch('/cart.js')).json();}catch(e){}
  if(btn){btn.disabled=false;btn.textContent='Appliquer';}
  var applied=false;
  if(after){
    var apps=after.cart_level_discount_applications||[];
    for(var i=0;i<apps.length;i++){if((apps[i].title||'').toUpperCase()===code.toUpperCase())applied=true;}
    if(!applied&&before&&after.total_price<before.total_price)applied=true;
    if(!applied&&after.items){
      outer:
      for(var j=0;j<after.items.length;j++){
        var alls=after.items[j].discount_allocations||[];
        for(var k=0;k<alls.length;k++){
          var app=after.discount_applications&&after.discount_applications[alls[k].discount_application_index];
          if(app&&(app.title||'').toUpperCase()===code.toUpperCase()){applied=true;break outer;}
        }
      }
    }
  }
  if(msg){
    msg.style.display='block';
    if(applied){msg.style.color='#16a34a';msg.textContent='Code '+code.toUpperCase()+' appliqué ✓';}
    else{msg.style.color='#dc2626';msg.textContent='Code invalide ou non applicable à ce panier.';}
  }
  if(applied)inp.value='';
  loadCart();
}

window.openCartDrawer=openCartDrawer;window.closeCartDrawer=closeCartDrawer;window.loadCart=loadCart;window.updateQty=updateQty;window.removeItem=removeItem;window.addUpsellToCart=addUpsellToCart;window.toggleCartPromo=toggleCartPromo;window.applyCartPromo=applyCartPromo;
document.addEventListener('submit',function(e){var form=e.target.closest?e.target.closest('form[action="/cart/add"]'):null;if(!form)return;e.preventDefault();fetch('/cart/add.js',{method:'POST',body:new FormData(form)}).then(function(){openCartDrawer();}).catch(function(){});},true);
document.addEventListener('DOMContentLoaded',function(){var els=document.querySelectorAll('a[href="/cart"],[data-cart-drawer-open]');for(var i=0;i<els.length;i++){els[i].addEventListener('click',function(e){e.preventDefault();openCartDrawer();});}});
})();
